<template>
  <CommonLayout header="ManagementHeader" footer="ManagementFooter">
    <div class="container">
      <div class="main-color text-light row mt-3">
        <div class="col p-2">
          企画画像登録
        </div>
      </div>
      <form method="post" action="#" class="form-horizontal">
        <b-overlay :show="overlayShow" rounded="sm">
          <div class="row base-color">

            <div class="col-sm-12 row p-3">
              <div class="col-sm-6">
                企画画像をセットし、登録してください。
              </div>
            </div>
            <div class="col-sm-12">
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td class="p-1 font-weight-bold light-blue h5">商品名</td>
                    <td class="p-1 font-weight-bold h5" colspan="3">{{getPlanItem('itemName')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">商品コード</td>
                    <td class="p-1">{{getPlanItem('itemCode')}}</td>
                    <td class="p-1 light-blue">大区分</td>
                    <td class="p-1">{{getPlanItem('sectionL')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">中区分</td>
                    <td class="p-1">{{getPlanItem('sectionM')}}</td>
                    <td class="p-1 light-blue">小区分</td>
                    <td class="p-1">{{getPlanItem('sectionS')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">季節</td>
                    <td class="p-1">{{getPlanItem('season')}}</td>
                    <td class="p-1 light-blue">色</td>
                    <td class="p-1">{{getPlanItem('color')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">スタイル</td>
                    <td class="p-1">{{getPlanItem('style')}}</td>
                    <td class="p-1 light-blue">メーカー</td>
                    <td class="p-1">{{getPlanItem('maker')}}</td>
                  </tr>
                  <tr>
                    <td class="p-1 light-blue">形</td>
                    <td class="p-1">{{getPlanItem('shape')}}</td>
                    <td class="p-1 light-blue">形態</td>
                    <td class="p-1">{{getPlanItem('configuration')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-sm-12 m-auto row pt-4">
              <div class="col-sm-6">
                <!-- 代表画像 -->
                <div class="card">
                  <img id="image-1" class="card-img-top main-img w-100 h-100" :src="images[1] !== null ? images[1] : noImage" @click="displayPreview">
                  <div class="card-body pb-2">
                    <p class="card-title">代表画像</p>
                    <div class="row">
                      <div class="col" v-show="images[1] !== null">
                        <button type="button" class="btn pl-0">
                          <b-icon class="text-primary" icon="arrow-clockwise" @click="rotateImage(1)"></b-icon>
                        </button>
                      </div>
                      <div class="text-right text-primary col text-nowrap pt-2">
                        <a class="text-primary" v-if="images[1] === null" @click="uploadImage(1)">画像を登録</a>
                        <a class="text-primary" v-else @click="deleteImage(1)">画像クリア</a>
                      </div>
                      <input id="image-file-input-1" class="d-none" type="file" @change="registImage">
                    </div>
                  </div>
                </div>
              </div>
              <!-- プレビュー領域 -->
              <div class="col-sm-6">
                <div class="bg-dark">
                  <img class="w-100 h-100 preview" :src="previewSrc">
                </div>
              </div>
            </div>

            <div class="col-sm-12 m-auto card-deck pt-4 pb-5">
              <div class="card" v-for="index in 4" :key="index">
                <img :id="'image-' + (index + 1)" class="card-img-top sub-img w-100 h-100" :src="images[index + 1] !== null ? images[index + 1] : noImage" @click="displayPreview">
                <div class="card-body pb-2">
                  <p class="card-title">画像{{index + 1}}</p>
                  <div class="row">
                    <div class="col" v-show="images[index + 1] !== null">
                      <button type="button" class="btn pl-0">
                        <b-icon class="text-primary" icon="arrow-clockwise" @click="rotateImage(index + 1)"></b-icon>
                      </button>
                    </div>
                    <div class="text-right col text-nowrap pt-2">
                      <a class="text-primary" v-if="images[index + 1] === null" @click="uploadImage(index + 1)">画像を登録</a>
                      <a class="text-primary" v-else @click="deleteImage(index + 1)">画像クリア</a>
                    </div>
                    <input :id="'image-file-input-' + (index + 1)" class="d-none" type="file" @change="registImage">
                  </div>
                </div>
              </div>
            </div>

          </div>
        </b-overlay>
      </form>
    </div>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import PlanImageModel from '@/models/PlanImageModel'

export default {
  name: 'PlanImage',
  components: { CommonLayout, CommonModal },
  data () {
    return {
      overlayShow: false,
      noImage: '/static/NoImage.png',
      previewSrc: '/static/preview.png',
      images: {}
    }
  },
  mounted () {
    this.setPlan()
  },
  methods: {
    setPlan: async function () {
      this.overlayShow = true
      const reqData = {
        'itemCode': this.$route.params.itemCode
      }
      const result = await PlanImageModel.getApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      if (result === undefined && result.response === undefined) {
        // 未認証状態でアクセスした場合。ログイン後のリダイレクトページを設定する。
        sessionStorage['loginRedirect'] = '/plan_image/' + this.$route.params.itemCode
        this.$router.push('/login')
      } else if (result.response && result.response.status === 403) {
        // 日比谷花壇ユーザー以外のユーザーがアクセスした場合
        this.$router.push('/project_list')
      }
      for (let i = 1; i <= 5; i++) {
        this.$set(this.images, i, null)
      }
      this.getPlanImage()
    },
    getPlanItem (key) {
      const store = PlanImageModel.getStore()
      if (!store || store['items'] === null) {
        return null
      }
      return store['items'][key]
    },
    getPlanImage () {
      const store = PlanImageModel.getStore()
      if (!store || store['images'] === null) {
        return null
      }
      for (let i in store['images']) {
        this.$set(this.images, store['images'][i]['displayOrderNumber'], store['images'][i]['imagePath'])
      }
    },
    uploadImage (displayOrderNumber) {
      document.getElementById('image-file-input-' + displayOrderNumber).click()
    },
    registImage: async function (e) {
      if (typeof e.target.files[0] === 'undefined') {
        return false
      }

      this.overlayShow = true

      const file = e.target.files[0]
      if (file.size > 5000000) {
        this.$refs.commonModal.confirmBox('アップロード可能なファイルサイズ上限は5MBです。')
        this.overlayShow = false
        return false
      }
      if (file.type !== 'image/jpeg') {
        this.$refs.commonModal.confirmBox('アップロード可能なファイルは.jpgまたは.jpegのみです。')
        this.overlayShow = false
        return false
      }

      const dataUrl = await this.toDataUrl(file)
      const displayOrderNumber = e.target.id.substr(-1)
      const reqData = {
        'itemCode': this.$route.params.itemCode,
        'regist': [
          {
            'fileName': file.name,
            'displayOrderNumber': displayOrderNumber,
            'imageData': dataUrl.replace(/^.*,/, '')
          }
        ],
        'delete': []
      }
      const result = await PlanImageModel.postApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      this.$set(this.images, displayOrderNumber, result['images']['imagePath'])
    },
    toDataUrl (file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
      })
    },
    rotateImage: async function (displayOrderNumber) {
      this.overlayShow = true
      const reqData = {
        'itemCode': this.$route.params.itemCode,
        'displayOrderNumber': String(displayOrderNumber),
        'imagePath': document.getElementById('image-' + displayOrderNumber).src
      }
      const result = await PlanImageModel.putApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      this.$set(this.images, displayOrderNumber, result['images']['imagePath'])
    },
    deleteImage: async function (displayOrderNumber) {
      this.overlayShow = true
      const reqData = {
        'itemCode': this.$route.params.itemCode,
        'displayOrderNumber': String(displayOrderNumber),
        'delete': document.getElementById('image-' + displayOrderNumber).src
      }
      await PlanImageModel.deleteApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      this.$set(this.images, displayOrderNumber, null)
    },
    displayPreview (e) {
      this.previewSrc = e.target.src
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PlanImage.vue